import Grid from '@mui/material/Grid'
import cx from 'classnames'
import dayjs from 'dayjs'
import InfoToolTipIcon from './InfoToolTipIcon'
import { includes, range } from 'libraries/lodash'
import Icon from 'components/shared/Icon'
import { LONG_DAY_FORMAT, SHORT_DAY_FORMAT } from 'constants/locale'
import { CaEmailDays } from 'types/User'

interface Props {
  caEmailDays: CaEmailDays
  handleChange: (value: number) => void
}

const tootTipTitle = 'These options allow you to select which days of the week you would like to receive Current Awareness emails. ' +
  'If you select just one day, you will receive all daily articles for the whole week in one email.'

const SelectSharedEmailDays = ({ caEmailDays, handleChange }: Props): JSX.Element => (
  <Grid container className='pv6 pl5 pr5 pr0-t' spacing={1}>
    <Grid item xs={12} sm={7} md={6}>
      <div className='flex items-center'>
        <div className='mr2 mr1'>
          <InfoToolTipIcon title={tootTipTitle} />
        </div>
        <span>Chosen days of week to receive emails</span>
      </div>
    </Grid>
    <Grid item xs={12} sm={5} md={6} style={{ backgroundColor: 'unset' }}>
      <Grid container spacing={1}>
        {range(1, 6).map((weekDayNumber, index) => (
          <CaEmailDayCheckBox
            key={index}
            id={`caEmailDays-${weekDayNumber}`}
            checked={includes(caEmailDays, weekDayNumber)}
            {...{ weekDayNumber, handleChange }}
          />
        ))}
      </Grid>
    </Grid>
  </Grid>
)

const CaEmailDayCheckBox = ({
  handleChange,
  checked,
  id,
  weekDayNumber
}: {
  handleChange: (value: number) => void
  checked: boolean
  id: string
  weekDayNumber: number
}): JSX.Element => {
  const iconName = checked ? 'icon-checkbox-marked' : 'icon-checkbox-blank-thin-outline'

  return (
    <Grid item xs={12} sm={12} md={12} lg={2} style={{ backgroundColor: 'unset' }}>
      <input
        className='dn' type='checkbox' {...{ checked, id }}
        onChange={() => handleChange(weekDayNumber)}
      />
      <label
        htmlFor={id}
        className={cx(
          'flex items-center lighter mb0 pointer account-input-label',
          { 'account-input-checked': checked }
        )}
      >
        <Icon className={cx('w7 mr2')} name={iconName} />
        <span className={cx({ teal: checked })}>
          <span className='dn-t db-d'>
            {dayjs().day(weekDayNumber).format(SHORT_DAY_FORMAT)}
          </span>
          <span className='db-m dn-d'>
            {dayjs().day(weekDayNumber).format(LONG_DAY_FORMAT)}
          </span>
        </span>
      </label>
    </Grid>
  )
}

export default SelectSharedEmailDays
